import React, { useEffect, useRef, useState } from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import Pass from './Pass';
import Club from './Club';
import NoMatch from './NoMatch';
import Games from './Games';
import Edit from './Edit';
import User from './User';
import Row from './Row';
import Invite from './Invite';
import Lottery from './Lottery';

const SCROLL_STEP = 300;

const arrowStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 28,
  height: 28,
  border: '1px solid white',
  background: 'transparent',
  color: 'white',
  cursor: 'pointer',
};

/**
 * SquarePasses component. The matrix scrolls sideways past ~6 columns (see
 * SquarePasses.scss), but with many game rows the native scrollbar sits at
 * the very bottom of a tall box, so nothing above the fold hints that it's
 * there. These arrows are a visible affordance for the same scroll — shown
 * only while there's actually overflow to scroll to.
 * @param {Object} [props]
 * @param {*} [props.children]
 * @component
 */
const SquarePasses = ({ children = null }) => {
  const bodyRef = useRef(null);
  const [canScroll, setCanScroll] = useState(false);

  useEffect(() => {
    const measure = () => {
      if (!bodyRef.current) return;
      setCanScroll(bodyRef.current.scrollWidth > bodyRef.current.clientWidth);
    };
    measure();
    window.addEventListener('resize', measure);
    return () => window.removeEventListener('resize', measure);
  }, [children]);

  const scrollBy = (delta) => () => {
    if (bodyRef.current) bodyRef.current.scrollBy({ left: delta, behavior: 'smooth' });
  };

  return (
    <div>
      {canScroll && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 6, marginBottom: 8 }}>
          <button type="button" style={arrowStyle} onClick={scrollBy(-SCROLL_STEP)} aria-label="Nach links">
            <FaChevronLeft size={12} />
          </button>
          <button type="button" style={arrowStyle} onClick={scrollBy(SCROLL_STEP)} aria-label="Nach rechts">
            <FaChevronRight size={12} />
          </button>
        </div>
      )}

      <div className="SquarePasses" ref={bodyRef}>
        {children}
      </div>
    </div>
  );
};

SquarePasses.Pass = Pass;
SquarePasses.Club = Club;
SquarePasses.NoMatch = NoMatch;
SquarePasses.Games = Games;
SquarePasses.Edit = Edit;
SquarePasses.User = User;
SquarePasses.Row = Row;
SquarePasses.Invite = Invite;
SquarePasses.Lottery = Lottery;

export default SquarePasses;
